<template>
  <v-container fluid>
    <v-row>
      <v-col lg="8" class="px-4">
        <v-row class="px-4 my-4">
          <v-col>
            <h1 class="text-h5">{{ $t("tutorial.welcome") }}</h1>
            <br />
            <p>
              {{ $t("tutorial.info1") }}
            </p>
            <ul>
              <li>{{ $t("tutorial.item1") }}</li>
              <li>{{ $t("tutorial.item2") }}</li>
              <li>{{ $t("tutorial.item3") }}</li>
              <li>{{ $t("tutorial.item4") }}</li>
            </ul>
            <br />
            <p class="text-justify">
              {{ $t("tutorial.infolong") }}
            </p>
            <p class="text-justify">
              {{ $t("tutorial.info2") }}
            </p>
            <p class="text-justify">
              {{ $t("tutorial.end") }}
            </p>
            <a v-if="pdf" @click="downloadPDF()">
              <v-icon large color="primary"> mdi-download-box-outline </v-icon>
              {{ $t("tutorial.download") }}
            </a>
            <p v-else>
              <v-icon large> mdi-download-box-outline </v-icon>
              {{ $t("tutorial.download") }}
              {{ $t("tutorial.soon") }}
            </p>
          </v-col>
        </v-row>
        <v-row v-if="url" class="px-4 my-4">
          <video-player :url="url"></video-player>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import VideoPlayer from "../components/AppVideoPlayer.vue";
import { monitore } from "../components/helpers/helpers";
export default {
  data() {
    return {
      video: "",
      pdf: "",
      url: "",
    };
  },
  components: {
    VideoPlayer,
  },
  beforeMount() {
    this.loadTutorial();
  },
  computed: {
    ...mapGetters(["user"]),
  },
  methods: {
    async downloadPDF() {
      let url = "/pdf/" + this.pdf;
      var request = { method: "GET", url: url, responseType: "blob" };
      try {
        var response = await this.axios(request);
        const blob = new Blob([response.data], { type: "application/pdf" });
        var data = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.style = "display: none";
        a.href = data;
        a.download = "Tuto BDSR";
        document.body.appendChild(a);
        a.click();
        monitore("Download rule pdf", "tuto");
      } catch (err) {
        this.pdf = "";
        console.log(err);
      }
    },
    async loadTutorial() {
      let request = { method: "GET", url: "/tutorial" };
      try {
        let response = await this.axios(request);
        this.video = response.data[0].video;
        this.pdf = response.data[0].pdf;
        if (this.video) {
          this.url = `${process.env.VUE_APP_BASE_ROOT}/video/${this.video}?token=${this.user.id_token}`;
        } else {
          this.url = "";
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>